import InterpolatingUtil from 'utils/activity/InterpolatingUtil';

/** @typedef {import('reducers/multiSportEdit/types/entity/IndexData').IndexData} IndexData */

/**
 * Interpolates an arbitrary metric based on timestamp
 *
 * @param {number} referenceTimestamp interpolate based on this timestamp
 * @param {number[]} directTimestamp
 * @param {number[]} metrics the metrics array for the desired metrics
 * @param {number} idx
 * @returns {number}
 */
export const interpolateMetric = (referenceTimestamp, directTimestamp, metrics, idx) => {
    const a = directTimestamp[idx - 1];
    const a1 = directTimestamp[idx];
    let b = metrics[idx - 1];
    let b1 = metrics[idx];
    !b && (b = b1);
    !b1 && (b1 = b);
    const newMetric = InterpolatingUtil.linearInterpolating(a, b, a1, b1, referenceTimestamp);
    return newMetric;
};

/**
 *
 * @param {number} refVal
 * @param {number[]} t directTimestamp
 * @param {number[]} d sumDistance
 * @param {number} idx index in t and d such as t[idx-1] < refVal < t[idx]
 * @return {number}
 */
export const interpolateDistance = (refVal, t, d, idx) => {
    const a = t[idx - 1],
        a1 = t[idx];
    const b = d[idx - 1],
        b1 = d[idx];
    const newDistance = InterpolatingUtil.linearInterpolating(a, b, a1, b1, refVal);
    return newDistance;
};

/**
 *
 * @param {number} referenceDistance
 * @param {number[]} directTimestamp
 * @param {number[]} sumDistance
 * @param {number} idx index in t and d such as d[idx-1] < referenceDistance < d[idx]
 */
export const interpolateTimestamp = (referenceDistance, directTimestamp, sumDistance, idx) => {
    const a = directTimestamp[idx - 1],
        a1 = directTimestamp[idx];
    const b = sumDistance[idx - 1],
        b1 = sumDistance[idx];
    const newTimestamp = InterpolatingUtil.timestampInterpolating(a, b, a1, b1, referenceDistance);
    return newTimestamp;
};

//@todo might fail when sumDuration has two consecutive equal values
export const interpolateTimestampFromSumDuration = (referenceDuration, directTimestamp, sumDuration, idx) => {
    const a = sumDuration[idx - 1];
    const a1 = sumDuration[idx];
    const b = directTimestamp[idx - 1];
    const b1 = directTimestamp[idx];
    const newTimestamp = InterpolatingUtil.linearInterpolating(a, b, a1, b1, referenceDuration);
    return newTimestamp;
};
